import { PogNonCircular } from "@CommonTypes/merchflow/pog/pog";
import { ExtractRouteParams } from "@CommonUtils/routes";
import type { PsaAisleSplitSuggestion } from "@CommonUtils/psa/aisleSplitGap";

export const RouteGetCategories_categoryId_Stores_storeId_FixturesPog =
  "/categories/:categoryId/stores/:storeId/fixtures-pog";

export type ParamsGetCategories_categoryId_Stores_storeId_FixturesPog = ExtractRouteParams<
  typeof RouteGetCategories_categoryId_Stores_storeId_FixturesPog
>;

/** One of the store's aisle breaks, and who set it. */
export interface FixturesPogAisleBreak {
  /** The bay the break follows, numbered from 1 as the pog numbers its bays. */
  afterBayNo: number;
  /** That bay's `uniqueId` in this response. */
  bayUniqueId: string;
  /** `declared_csv` from the fixture file, `declared_ui` from the store fixtures editor. */
  source: "declared_csv" | "declared_ui";
  /** Who set it in the editor; null from the fixture file, or set before users were recorded. */
  declaredBy: number | null;
  /** That user's first name, for "Set by Wendy"; null when there is no user. */
  declaredByName: string | null;
  /** ISO time it was set in the editor; null from the fixture file. */
  declaredAt: string | null;
}

/** The store's fixtures as a pog. Each bay's `uniqueId` names its stored section: a save that
 *  sends the bays back with those ids keeps the writer of every break it only kept. */
export type ResponseGetCategories_categoryId_Stores_storeId_FixturesPog = PogNonCircular & {
  aisleBreaks: FixturesPogAisleBreak[];
  /** From the store's latest PSA, minus seams already declared; never drawn as breaks. */
  aisle_break_suggestions: PsaAisleSplitSuggestion[];
};

export const RoutePostCategories_categoryId_Stores_storeId_FixturesPog =
  RouteGetCategories_categoryId_Stores_storeId_FixturesPog;

export type ParamsPostCategories_categoryId_Stores_storeId_FixturesPog =
  ParamsGetCategories_categoryId_Stores_storeId_FixturesPog;

export type PayloadPostCategories_categoryId_Stores_storeId_FixturesPog = PogNonCircular;

/** The fixtures as saved, as the GET returns them: send these bay ids with the next save. */
export type ResponsePostCategories_categoryId_Stores_storeId_FixturesPog =
  ResponseGetCategories_categoryId_Stores_storeId_FixturesPog;
